import { Injectable } from '@angular/core';
import {
  HttpBackend,
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { mapHttpResponseByMock, serializeError, serializeRequest, serializeResponse } from './utils';

@Injectable()
export class RecorderInterceptor implements HttpInterceptor {
  private readonly httpClient: HttpClient;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // TODO parametrize this condition
    if (request.url.match(/\.json$/)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      switchMap((response: HttpResponse<any>) => {
        if (!(response instanceof HttpResponse)) {
          return of(response);
        }

        return this.httpClient
          .post('/mocks/scenario', {
            request: serializeRequest(request),
            response: serializeResponse(response)
          })
          .pipe(map(mapHttpResponseByMock));
      }),
      catchError(error => {
        if (!(error instanceof HttpErrorResponse)) {
          return throwError(error);
        }

        return this.httpClient
          .post('/mocks/scenario', {
            request: serializeRequest(request),
            error: serializeError(error)
          })
          .pipe(switchMap(() => throwError(error)));
      })
    );
  }
}
